export default {"src":"/_next/static/media/usdt.bf9abe98.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};